import React, { useEffect } from "react";
import { useDogSchoolApi } from "../../../context";
import { useStaticData } from "../../../hooks/useStaticData";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";
import SchoolLocationFilters from "../../filters/SchoolLocationFilters/SchoolLocationFilters";
import * as styles from "./SectionDogSchoolSearch.module.scss";

// TODO - TEST STATIC
export const SectionDogSchoolSearch: React.FC = () => {
	const { dogClassRegions } = useStaticData(["dogClassRegions"]);

	const { onLoadDogSchoolRegions } = useDogSchoolApi();

	useEffect(() => {
		onLoadDogSchoolRegions(dogClassRegions);
	}, [onLoadDogSchoolRegions, dogClassRegions]);
	return (
		<WrappedSection
			sectionName="SectionDogSchoolSearch"
			sectionColour={Colours.SANDY_FUR}
		>
			<div className={styles.dogschoolsearchinner}>
				<SchoolLocationFilters />
			</div>
		</WrappedSection>
	);
};

export default SectionDogSchoolSearch;
